export default __webpack_public_path__ + "static/media/1.3bbc90d0.png";